import getters from './getters';
// import actions from './actions';
// import mutations from './mutations';

interface IState {
  initial: number;
}

const defaultState = (): IState => {
  return {
    initial: 1,
  }
};

const module = {
  namespaced: true,
  state: defaultState,
  getters,
  // mutations,
  // actions
};

export { module as default, IState };
